import { render, staticRenderFns } from "./ResultInfo.vue?vue&type=template&id=3c598320&lang=html"
import script from "./ResultInfo.vue?vue&type=script&lang=js"
export * from "./ResultInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports